/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type AccessEnrollmentProgressionRequestFlowName =
  (typeof AccessEnrollmentProgressionRequestFlowName)[keyof typeof AccessEnrollmentProgressionRequestFlowName];

export const AccessEnrollmentProgressionRequestFlowName = {
  access_eckm_enrollment: "access_eckm_enrollment",
  access_ckm_enrollment: "access_ckm_enrollment",
  access_behavioral_health_enrollment: "access_behavioral_health_enrollment",
} as const;
